import {
  getRootParkAndCust, getParkByCurrUser, exportParkSHRoadData, getParkPayParams,
  getCustByGroup, getPlatCardGroup, getAllParkParamByParkId, getChannelByQuery, getParkingLockQuery, getParkingGeoQuery, getShappRegisterList, getParkDevCamQuery, getEhallCardTimeoutQuery, parkGeoDataUpload, importParkGeoData, getFilterPlateCodeQuery, getChannelParamById, getMapAndParkType, saveParkPay,
  getChannelSelectParam, savePark, deletePark, synParkById, saveChannel, saveParkLock, saveParkLockNotifyConfig, saveParkGeomagnetic, saveShappRegister, saveFilterPlateCode, deleteChannel, deleteParkLock, deleteParkGeo, sendSMS, parkGeoDataTemplate, deleteFilterPlateCode, importFilterPlateCodeData, filterPlateCodeUpload, filterPlateCodeDataTemplate, ascParkLock, descParkLock, descOrAecParkLock, getParkLockStatus, synChnlById, getParkList, getCustomizedCardParkList, getParkLockConfiguration, getParkPayLink,
  deleteRoadSidePark, saveRoadSidePark, getRoadSideParkParams, getPayUrl, getParkOtherSetByCurrUser, getAllParkOtherSetParam, saveParkOtherSet
} from '../../../api/park.js'
const state = {
}
// mutations
const mutations = {
  setState (state, groupInfo) {
  }
}
// actios
const actions = {
  getRootParkAndCust ({ commit }, param) {
    return new Promise((resolve, reject) => {
      getRootParkAndCust(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getParkByCurrUser ({ commit }, param) {
    return new Promise((resolve, reject) => {
      getParkByCurrUser(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getParkOtherSetByCurrUser ({ commit }, param) {
    return new Promise((resolve, reject) => {
      getParkOtherSetByCurrUser(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getAllParkOtherSetParam ({ commit }, param) {
    return new Promise((resolve, reject) => {
      getAllParkOtherSetParam(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  saveParkOtherSet ({ commit }, param) {
    return new Promise((resolve, reject) => {
      saveParkOtherSet(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  exportParkSHRoadData ({ commit }, param) {
    return new Promise((resolve, reject) => {
      exportParkSHRoadData(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getParkPayParams ({ commit }, param) {
    return new Promise((resolve, reject) => {
      getParkPayParams(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getPayUrl ({ commit }, param) {
    return new Promise((resolve, reject) => {
      getPayUrl(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getCustByGroup ({ commit }, param) {
    return new Promise((resolve, reject) => {
      getCustByGroup(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getPlatCardGroup ({ commit }, param) {
    return new Promise((resolve, reject) => {
      getPlatCardGroup(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getAllParkParamByParkId ({ commit }, param) {
    return new Promise((resolve, reject) => {
      getAllParkParamByParkId(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getChannelByQuery ({ commit }, param) {
    return new Promise((resolve, reject) => {
      getChannelByQuery(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getParkingLockQuery ({ commit }, param) {
    return new Promise((resolve, reject) => {
      getParkingLockQuery(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getParkingGeoQuery ({ commit }, param) {
    return new Promise((resolve, reject) => {
      getParkingGeoQuery(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getShappRegisterList ({ commit }, param) {
    return new Promise((resolve, reject) => {
      getShappRegisterList(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getParkDevCamQuery ({ commit }, param) {
    return new Promise((resolve, reject) => {
      getParkDevCamQuery(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getEhallCardTimeoutQuery ({ commit }, param) {
    return new Promise((resolve, reject) => {
      getEhallCardTimeoutQuery(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  parkGeoDataUpload ({ commit }, param) {
    return new Promise((resolve, reject) => {
      parkGeoDataUpload(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  importParkGeoData ({ commit }, param) {
    return new Promise((resolve, reject) => {
      importParkGeoData(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getFilterPlateCodeQuery ({ commit }, param) {
    return new Promise((resolve, reject) => {
      getFilterPlateCodeQuery(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getChannelParamById ({ commit }, param) {
    return new Promise((resolve, reject) => {
      getChannelParamById(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getMapAndParkType ({ commit }, param) {
    return new Promise((resolve, reject) => {
      getMapAndParkType(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getChannelSelectParam ({ commit }, param) {
    return new Promise((resolve, reject) => {
      getChannelSelectParam(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  savePark ({ commit }, param) {
    return new Promise((resolve, reject) => {
      savePark(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  saveParkPay ({ commit }, param) {
    return new Promise((resolve, reject) => {
      saveParkPay(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  deletePark ({ commit }, param) {
    return new Promise((resolve, reject) => {
      deletePark(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  synParkById ({ commit }, param) {
    return new Promise((resolve, reject) => {
      synParkById(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  saveChannel ({ commit }, param) {
    return new Promise((resolve, reject) => {
      saveChannel(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  saveParkLock ({ commit }, param) {
    return new Promise((resolve, reject) => {
      saveParkLock(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  saveParkLockNotifyConfig ({ commit }, param) {
    return new Promise((resolve, reject) => {
      saveParkLockNotifyConfig(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  saveParkGeomagnetic ({ commit }, param) {
    return new Promise((resolve, reject) => {
      saveParkGeomagnetic(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  saveShappRegister ({ commit }, param) {
    return new Promise((resolve, reject) => {
      saveShappRegister(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  saveFilterPlateCode ({ commit }, param) {
    return new Promise((resolve, reject) => {
      saveFilterPlateCode(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  deleteChannel ({ commit }, param) {
    return new Promise((resolve, reject) => {
      deleteChannel(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  deleteParkLock ({ commit }, param) {
    return new Promise((resolve, reject) => {
      deleteParkLock(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  deleteParkGeo ({ commit }, param) {
    return new Promise((resolve, reject) => {
      deleteParkGeo(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  sendSMS ({ commit }, param) {
    return new Promise((resolve, reject) => {
      sendSMS(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  parkGeoDataTemplate ({ commit }, param) {
    return new Promise((resolve, reject) => {
      parkGeoDataTemplate(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  deleteFilterPlateCode ({ commit }, param) {
    return new Promise((resolve, reject) => {
      deleteFilterPlateCode(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  importFilterPlateCodeData ({ commit }, param) {
    return new Promise((resolve, reject) => {
      importFilterPlateCodeData(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  filterPlateCodeUpload ({ commit }, param) {
    return new Promise((resolve, reject) => {
      filterPlateCodeUpload(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  filterPlateCodeDataTemplate ({ commit }, param) {
    return new Promise((resolve, reject) => {
      filterPlateCodeDataTemplate(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  ascParkLock ({ commit }, param) {
    return new Promise((resolve, reject) => {
      ascParkLock(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  descParkLock ({ commit }, param) {
    return new Promise((resolve, reject) => {
      descParkLock(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  descOrAecParkLock ({ commit }, param) {
    return new Promise((resolve, reject) => {
      descOrAecParkLock(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getParkLockStatus ({ commit }, param) {
    return new Promise((resolve, reject) => {
      getParkLockStatus(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  synChnlById ({ commit }, param) {
    return new Promise((resolve, reject) => {
      synChnlById(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getParkList ({ commit }, param) {
    return new Promise((resolve, reject) => {
      getParkList(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getCustomizedCardParkList ({ commit }, param) {
    return new Promise((resolve, reject) => {
      getCustomizedCardParkList(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getParkLockConfiguration ({ commit }, param) {
    return new Promise((resolve, reject) => {
      getParkLockConfiguration(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getParkPayLink ({ commit }, param) {
    return new Promise((resolve, reject) => {
      getParkPayLink(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  deleteRoadSidePark ({ commit }, param) {
    return new Promise((resolve, reject) => {
      deleteRoadSidePark(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  saveRoadSidePark ({ commit }, param) {
    return new Promise((resolve, reject) => {
      saveRoadSidePark(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getRoadSideParkParams ({ commit }, param) {
    return new Promise((resolve, reject) => {
      getRoadSideParkParams(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/park/park.js